<template>
  <b-button
    :class="[
      'icon-button',
      {
        'icon-button--is-column': isColumn,
        'icon-button--is-disabled': disabled,
      },
    ]"
    @click="$emit('action')"
  >
    <component
      :is="getIcon(icon)"
      :class="['icon-button__svg', { 'icon-button__svg-is-column': isColumn }]"
    />

    <span class="icon-button__label">
      {{ label }}
    </span>
  </b-button>
</template>

<script>
export default {
  name: "IconButton",

  components: {
    SvgGlossary: () => import("@/assets/svgs/glossary.svg?inline"),
    SvgHelp: () => import("@/assets/svgs/help.svg?inline"),
    SvgHome: () => import("@/assets/svgs/home.svg?inline"),
    SvgList: () => import("@/assets/svgs/list.svg?inline"),
    SvgIsi: () => import("@/assets/svgs/ISI.svg?inline"),
  },

  props: {
    label: {
      type: String,
      default: "button icon",
    },
    icon: {
      type: String,
      default: "home",
      validator: (value) =>
        ["glossary", "list", "help", "isi", "home"].includes(value),
    },
    isColumn: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getIcon(svg) {
      return `svg-${svg}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-button {
  background: transparent;
  border: 0;
  padding: 0;
  border-radius: 0;

  @include flexbox(center, flex-start);

  &__svg {
    width: rem(20);

    @include iPadProStyles {
      width: rem(24);
    }
    path {
      fill: $white;
    }
  }

  @include iPadProStyles {
    &__svg-is-column {
      width: rem(30);
    }
  }

  &__label {
    margin-left: rem(35);
    font-size: rem(18);
    line-height: 1.25;
    text-transform: capitalize;
    color: $white;
    font-weight: $font-regular;
  }

  &--is-column {
    @include flexbox(center, center);
    flex-direction: column;

    .icon-button__label {
      margin-left: 0;
      text-transform: uppercase;
      font-size: rem(14);
      font-weight: $font-bold;

      @include iPadProStyles {
        font-size: rem(20);
      }
    }

    .icon-button__svg {
      margin-bottom: rem(10);

      @include iPadProStyles {
        font-size: rem(14);
      }
    }
  }

  &--is-disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:focus {
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
    border-color: $border !important;
  }
}
</style>
